import { CORE_CONSTANT, type ViewConfigKpiParameter } from '@salescore/core'
import { parseJsonIfValid } from '@salescore/frontend-common'
import { z } from 'zod'

import type { RSheetColumn, RSheetRecordNode } from '../domain/column'

/**
 * KPIピボットのカラムからKPI IDを取得する
 * @param kpiPivotParameter KPIピボットのパラメータ
 * @param column 対象のカラム
 * @returns KPI ID（見つからない場合はundefined）
 */
export function extractKpiId(
  kpiPivotParameter: ViewConfigKpiParameter,
  column: RSheetColumn<RSheetRecordNode>,
): string | undefined {
  const kpiIndex = kpiPivotParameter.pivot.columns.findIndex((x) => x.key === CORE_CONSTANT.KPI_PIVOT_KPI_DIMENSION.key)

  if (kpiIndex === -1) {
    return undefined
  }

  const columnValues = parseJsonIfValid(column.field?.name ?? '')
  const parsed = z.string().array().safeParse(columnValues)

  if (parsed.success) {
    return parsed.data[kpiIndex]
  }

  return undefined
}
